module.exports = __webpack_public_path__ + "img/people.a5b11006.svg";